import { ApplicationState } from '..';
import { User } from '../../models';

export const getCustomerServiceAgents = (state: ApplicationState): User[] => state.users.customerServiceAgents || [];
export const areCustomerServiceAgentsLoading = (state: ApplicationState): boolean => state.users.areCustomerServiceAgentsLoading;